import type { Basis, CardStatus, JobStatus, Verdict } from "../api/models";
import { formatStatus, formatVerdict } from "../lib/verdict";

export function VerdictBadge({ verdict }: { verdict: Verdict }) {
  const { label, className } = formatVerdict(verdict);
  return <span className={className}>{label}</span>;
}

export function StatusBadge({ status }: { status: CardStatus | JobStatus }) {
  const { label, className } = formatStatus(status);
  return <span className={className}>{label}</span>;
}

export function BasisBadge({ basis }: { basis: Basis }) {
  if (!basis) return <span className="badge">—</span>;
  return <span className={`badge badge-${basis}`}>{basis}</span>;
}
